import { render, staticRenderFns } from "./EventRatingsEditor.vue?vue&type=template&id=ceb9b144"
import script from "./EventRatingsEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventRatingsEditor.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports